import React from 'react';
import ReactDOM from 'react-dom/client';
import AdminApp from './AdminApp';
import 'bootstrap/dist/css/bootstrap.css';
import UserProvider from './UserContext';
import { BrowserRouter } from 'react-router';
import './index.css';
import './fontawesome';
import "react-datepicker/dist/react-datepicker.css";

// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <UserProvider>
                <AdminApp />
            </UserProvider>
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
